
<template>
  <div class="help_page">
    <div class="header_box">
      <p v-for="(item,index) in headeList"
         :key="index"
         @click="checkActive(index)"
         :class="{'active':isActive==index+1}">
        {{item}}
        <span class="line"
              v-show="isActive==index+1"></span>
      </p>
    </div>
    <div class="tab"
         v-if="isActive==1&&newsList.length>0">
      <div v-for="(item,index) in newsList"
           :key="index"
           @click="toArticleClick(item)">
        <div class="banner_box"
             v-if="item.hasAdv">
          <img :src="item.cover"
               alt="">
        </div>
        <div class="item"
             v-else>
          <div class="item_list"
               :class="{'noBorder':index==newsList.length-1}">
            <div class="left">
              <h4 class="name"
                  style="-webkit-box-orient: vertical;"><span class="isVip"
                      v-if="item.type.indexOf('2')!=-1"></span>{{item.title}}</h4>
              <p class="info"><span class="eyes"></span>{{item.peopleNum}}<span class="time">{{util.getTimer(item.time)}}</span></p>
            </div>
            <div class="right">
              <img :src="item.cover"
                   alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab"
         v-if="isActive==2&&topList.length>0">
      <div class="info_box">
        <div class="info_top"
             @click="toArticleClick(topList[0])">
          <img class="info_banner"
               :src="topList[0].cover"
               alt="">
          <p class="in_name_first">{{topList[0].title}}</p>
        </div>
        <div class="info_bottom"
             v-if="topList.length>=2">
          <div v-for="(item,index) in topList"
               :key="index"
               @click="toArticleClick(item)">
            <h4 class="in_name"
                v-if="index>=1"><span class="circle"></span>{{item.title}}</h4>
          </div>
        </div>
      </div>
      <div class="item"
           v-if="bottomList.length>0">
        <div v-for="(item,index) in bottomList"
             :key="index"
             @click="toArticleClick(item)">
          <div class="item_list"
               :class="{'noBorder':index==bottomList.length-1}"
               v-if="!item.hasAdv">
            <div class="left">
              <h4 class="name"
                  style="-webkit-box-orient: vertical;"><span class="isVip"
                      v-if="item.type.indexOf('2')!=-1"></span>{{item.title}}</h4>
              <p class="info"><span class="eyes"></span>{{item.peopleNum}}<span class="time">{{util.getTimer(item.time)}}</span></p>
            </div>
            <div class="right">
              <img :src="item.cover"
                   alt="">
            </div>
          </div>
          <div class="item_list"
               v-else>
            <img class="banner"
                 :src="item.cover"
                 alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="shadow"
         v-if="isShowToast"></div>
    <div class="toast"
         v-if="isShowToast">
      <p class="toast_name">VIP专享权益</p>
      <span class="close_btn"
            @click="toPost"></span>
      <span class="toOpen"
            @click="toPost(1)">立即开通</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      isShowToast: 0,
      hasMember: 0,
      headeList: [
        '推荐', '会员专享'
      ],
      newsList: [],
      topList: [],
      bottomList: [],
      isActive: 1,

    }
  },
  mounted () {
    this.util.title('热点资讯');
    this.isActive = this.$route.query.isActive ? this.$route.query.isActive : 1;
    this.getArticleList();
    this.getParam()
  },
  methods: {
    getParam () {
      let json = {}
      if (this.isActive == 1) {
        json = { event_key: 'h5_hotarticle_view' }
      } else {
        json = {
          event_key: 'h5_viparticle_view',
        }
      }
      this.toCountPoint(json);
    },
    checkActive (index) {
      this.isActive = index + 1;
      this.getParam();
      this.getArticleList();
    },
    toArticleClick (item) {
      if (item.hasAdv) {
        window.location.href = item.pageUrl;
      } else {
        let json = {
          event_key: this.isActive == 1 ? 'h5_hotarticle_article_click' : 'h5_viparticle_article_click',
          vip_article: item.article,
          vip_status: item.status,
          article_id: item.id
        }
        this.toCountPoint(json);
        this.hasMember = item.hasMember;
        if (this.hasMember == true || item.type.indexOf('2') == -1) {//是会员 或者 不是会员专属文章
          window.location.href = "/information/informationDetail?id=" + item.id;
        } else {
          this.isShowToast = 1
          // this.hasMember = true;
        }
      }

    },
    //统计埋点
    toCountPoint (json, pageUrl) {
      this.$get('/app/api/v1/newEventTrace', json)
        .then(res => {
          if (res.code == 200) {
          }
          else {
            this.util.toast({ msg: res.message })
          }
        })
        .catch(error => { });
    },
    toPost (val) {
      this.isShowToast = 0;
      if (val == 1) {
        window.location.href = "/vip/handleVip";
      }
    },
    getArticleList () {//
      let _this = this;
      let param = {
        type: this.isActive
      }
      this.$get('/app/v1/news/getByTypeNews', param)
        .then(res => {
          this.newsList = [];
          this.topList = [];
          this.bottomList = [];
          var e = res;
          let obj = {}
          let obj1 = {}
          if (e.code == 200) {
            if (_this.isActive == 1) {
              _this.newsList = e.data.newsList;
            } else {
              e.data.newsList.map(function (item, index) {
                if (index <= 3) {
                  obj = Object.assign(item)
                  _this.topList.push(obj)
                } else {
                  obj1 = Object.assign(item)
                  _this.bottomList.push(obj1)
                }
              })
            }
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.help_page {
  width: 100%;
  background: #fff;
  padding-bottom: 0.3rem;
}
.header_box {
  display: flex;
  justify-content: space-between;
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  text-align: center;
  padding: 0.1rem 0;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
}
.line {
  display: inline-block;
  width: 28px;
  height: 2px;
  background: rgba(79, 140, 250, 1);
  border-radius: 5px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: -0.03rem;
}
.active {
  color: #4f8cfa;
}
.header_box p {
  flex: 1;
  position: relative;
}
.banner_box {
  padding: 0.15rem;
  padding-top: 0.12rem;
  border-radius: 4px;
  padding-bottom: 0;
  /* height: 1.05rem; */
}
.banner_box img {
  width: 100%;
  height: 0.9rem;
  border-radius: 4px;
  display: block;
}
.info_box {
  margin: 0.15rem;
  padding-bottom: 0;
  box-shadow: 0px 0px 10px 0px rgba(82, 82, 82, 0.15);
  border-radius: 4px;
  margin-bottom: 0;
}
.info_bottom {
  padding: 0 0.1rem 0.15rem 0.1rem;
}
.info_banner {
  width: 100%;
  height: 1.12rem;
  border-radius: 4px;
  display: block;
}
.in_name_first {
  font-size: 0.14rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  bottom: 0.06rem;
  left: 0.08rem;
}
.circle {
  display: inline-block;
  width: 0.04rem;
  height: 0.04rem;
  background: #999;
  margin-right: 0.08rem;
  position: relative;
  top: -0.03rem;
}
.info_top {
  position: relative;
}
.in_name {
  font-size: 0.14rem;
  /* font-family: PingFangSC-Medium, PingFang SC; */
  /* font-weight: 500; */
  color: rgba(51, 51, 51, 1);
  margin-top: 0.13rem;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
}
.in_name:last-child {
  margin-bottom: 0;
}
.item_list {
  display: flex;
  justify-content: space-between;
  padding: 0.12rem 0;
  margin: 0 0.15rem;
  border-bottom: 1px solid #f5f5f5;
}
.noBorder {
  border-bottom: 0;
}
.left {
  flex: 1;
  margin-right: 0.19rem;
}
.name {
  font-size: 0.14rem;
  /* font-family: PingFangSC-Medium, PingFang SC; */
  /* font-weight: 500; */
  color: rgba(51, 51, 51, 1);
  height: 46px;
  line-height: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
}
.isVip {
  display: inline-block;
  width: 0.28rem;
  height: 0.14rem;
  border-radius: 2px;
  background: url('../../assets/img/information/vip_btn.png') no-repeat center
    center;
  background-size: 100%;
  position: relative;
  margin-right: 0.05rem;
  top: 0.015rem;
}
.info {
  font-size: 0.12rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-top: 0.1rem;
}
.time {
  float: right;
}
.eyes {
  display: inline-block;
  width: 0.11rem;
  height: 0.1rem;
  background: url('../../assets/img/information/eyes_btn.png') no-repeat top
    center;
  background-size: 100%;
  position: relative;
  top: 0.004rem;
  margin-right: 0.02rem;
}
.right {
  flex: 0 0 1.16rem;
  border-radius: 4px;
}
.right img {
  width: 100%;
  border-radius: 4px;
  height: 0.7rem;
  position: relative;
  top: 0.02rem;
  display: block;
}
.banner {
  width: 100%;
  height: 0.9rem;
  border-radius: 4px;
}
.shadow {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  opacity: 0.4;
  z-index: 11;
  position: fixed;
  left: 0;
  top: 0;
}
.toast {
  position: absolute;
  left: 50%;
  top: 1.15rem;
  transform: translate(-50%, 0%);
  color: #fff;
  z-index: 111;
  width: 2.55rem;
  margin: 0 auto;
  background: url('../../assets/img/information/toast_bg.png') no-repeat center
    center;
  background-size: 100% 100%;
  height: 3.23rem;
  text-align: center;
  padding-top: 0.3rem;
  padding-bottom: 0.24rem;
}
.close_btn {
  background: url('../../assets/img/information/toast_close_btn.png') no-repeat
    center center;
  background-size: 100% 100%;
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  position: absolute;
  right: 0.13rem;
  top: 0.17rem;
}
.toast_name {
  font-size: 0.26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 26px;
  letter-spacing: 2px;
  text-shadow: 0px 2px 4px rgba(0, 51, 150, 0.35);
}
.toOpen {
  display: inline-block;
  text-align: center;
  width: 2.25rem;
  height: 0.5rem;
  line-height: 50px;
  background: linear-gradient(
    180deg,
    rgba(250, 254, 255, 1) 0%,
    rgba(186, 223, 253, 1) 100%
  );
  box-shadow: 0px 2px 10px 0px rgba(0, 95, 210, 1);
  border-radius: 25px;
  font-size: 0.17rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(79, 140, 250, 1);
  position: absolute;
  bottom: 0.24rem;
  left: 0.15rem;
}
</style>

